module.exports = __webpack_public_path__ + "img/FR24599.77eb40d8.svg";